import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

const Container = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
`;

const Card = styled.div`
  background: rgba(2, 6, 23, 0.98);
  border-radius: 16px;
  border: 1px solid #4b5563;
  padding: 2rem 1.75rem;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.55);
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin-bottom: 0.75rem;
  color: #f9fafb;
`;

const Text = styled.p`
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  color: #e5e7eb;
`;

const Highlight = styled.p`
  margin: 0 0 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: #facc15;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.25rem;
`;

const PrimaryLink = styled(Link)`
  padding: 0.6rem 1.4rem;
  border-radius: 999px;
  border: none;
  background-color: #facc15;
  color: #111827;
  font-size: 0.95rem;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #fde047;
  }
`;

const SecondaryLink = styled(Link)`
  padding: 0.55rem 1.3rem;
  border-radius: 999px;
  border: 1px solid #4b5563;
  color: #e5e7eb;
  font-size: 0.9rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #9ca3af;
  }
`;

const BookingConfirmation: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const kind = searchParams.get('kind') === 'appointment' ? 'appointment' : 'consultation';

  const headline =
    kind === 'appointment'
      ? 'Your appointment request has been sent.'
      : 'Your consultation request has been sent.';

  const highlight =
    kind === 'appointment'
      ? "If a deposit is required to fully lock in this appointment, you'll see a separate deposit payment screen or hear back with instructions."
      : 'Consultations are free to book. Your artist will review your request and follow up to confirm a time.';

  return (
    <Container>
      <Card>
        <Title>Thanks for reaching out</Title>
        <Text>{headline}</Text>
        <Highlight>{highlight}</Highlight>
        <Text>
          You&apos;ll get a reply at the contact info you provided as soon as your artist has reviewed the details.
        </Text>

        <ButtonRow>
          <PrimaryLink to="/">Back to home</PrimaryLink>
          <SecondaryLink to="/booking">Submit another request</SecondaryLink>
        </ButtonRow>
      </Card>
    </Container>
  );
};

export default BookingConfirmation;
